import {SelectionBar} from "./SelectionBar.jsx";
import {DayElement} from "./DayElement.jsx";
import {useState} from "react";
import {Section} from "./Section.jsx";
import {Col, Row} from "react-bootstrap";
import {addMonths, endOfMonth, startOfMonth} from "date-fns";
import {ButtonCustom} from "./ButtonCustom.jsx";
import {TaskNote} from "./TaskNote.jsx";
import {DAY_NAMES_SHORT, MONTH_NUMBER, SHORT_MONTH_NAMES} from "../data/data.jsx";
import {
    addCurrentMonthDays,
    addEmptyDaysOfNextMonth,
    addEmptyDaysOfPrevMonth,
    dayMonthIsToday,
    taskIsCurrentDay,
    taskIsCurrentDayAndIsRepeat,
} from "../utilities/calendar_utilities";
import {IfAdmin, IfLoggedIn} from "../../ifLoggedIn";
import {useAuthenticated} from "../../../contexts/authenticationcontext";


export function CalendarMonth(props) {
    const {tasks, small, onOpenChange, onTaskEditingChange} = props;
    const [dateSelected, setDateSelected] = useState(new Date());

    return <Section className={`g-0 ${small ? "border border-black rounded-2" : ""}`}>
        <MonthSelector small={small} onOpenChange={onOpenChange} dateSelected={dateSelected}
                       onDateChanged={setDateSelected}
        />
        <Section>

            <DayOrderBar small={small} dayNames={DAY_NAMES_SHORT}/>
            <MonthGrid small={small} dateSelected={dateSelected} onTaskEditingChange={onTaskEditingChange}
                       onOpenChange={onOpenChange}
                       tasks={tasks}/>


        </Section>
    </Section>
}

function MonthSelector(props) {
    const {onOpenChange, small} = props
    const {dateSelected, onDateChanged} = props
    const {sectorControl} = useAuthenticated();
    return <SelectionBar className={'pt-2 mb-0'}>
        {small ? <></> :
            <IfLoggedIn>
                <IfAdmin>
                    <Row className={'g-0 mb-1 mt-2'}>
                        <Col className={"text-end pe-1"}>
                            {sectorControl === "ALL" ? <ButtonCustom className={"btn-primary"} title={'Nieuwe item'}
                                                            onClick={() => onOpenChange(true)}/> : ""}
                        </Col>
                    </Row>
                </IfAdmin>
            </IfLoggedIn>}

        <Col className={'text-end'}>
            <ButtonCustom btnSmall={true} className={"btn-sm btn-light shadow"} title={'<'}
                          onClick={() => onDateChanged(addMonths(dateSelected, -1))}/>
        </Col>
        <Col xs={"auto"} className={'text-center ms-2 me-2'}>
            <div className={"text-center mb-3"}>
                <p style={{color: 'black', fontWeight: "900"}}>{`${dateSelected.getFullYear()}`}</p>
                <p style={{color: 'black', fontWeight: "900"}}>{`${SHORT_MONTH_NAMES[dateSelected.getMonth()]}`}</p>
            </div>
        </Col>
        <Col className={"text-start"}>
            <ButtonCustom title={'>'} className={"btn-sm btn-light shadow"}
                          onClick={() => onDateChanged(addMonths(dateSelected, 1))}/>
        </Col>

    </SelectionBar>

}

function DayOrderBar(props) {
    const {dayNames, small} = props;
    return <Col xs={12}>
        <Row className={'g-0 justify-content-evenly'}>
            {dayNames.map((dayName, index) => <DayName small={small} key={index} dayName={dayName}/>)}
        </Row>
    </Col>
}

function DayName(props) {
    const {dayName} = props;
    return <Col xs={1} className={'text-center'}>
        <p>{dayName}</p>
    </Col>
}

function MonthGrid(props) {
    const {dateSelected, small, tasks, onTaskEditingChange, onOpenChange} = props;
    const startDate = startOfMonth(dateSelected);
    const endDate = endOfMonth(dateSelected);
    return <Row className={'g-0 justify-content-evenly'}>
        <EmptyDaysOfPrevMonth small={small} startDay={startDate}/>
        <CurrentMonthDays small={small} startDay={startDate} tasks={tasks} onTaskEditingChange={onTaskEditingChange}
                          onOpenChange={onOpenChange}
                          dateSelected={dateSelected}/>
        <EmptyDaysOfNextMonth small={small} endDay={endDate}/>
    </Row>

}

function EmptyDaysOfPrevMonth(props) {
    const {startDay, small} = props;
    return <>
        {addEmptyDaysOfPrevMonth(startDay).map((number, index) => <Col key={index}></Col>)}
    </>
}

function CurrentMonthDays(props) {
    const {startDay, tasks, dateSelected, small, onTaskEditingChange, onOpenChange} = props;

    return <>
        {addCurrentMonthDays(startDay)?.map(
            (type, index) => {
                if (type !== "newrow") {

                    const filteredTask = tasks?.filter(t => taskIsCurrentDay(t, Number(type), dateSelected));

                    return <Col key={index}>
                        <DayElement small={small} key={index} hasTask={filteredTask?.length > 0}
                                    today={dayMonthIsToday(dateSelected, Number(type))}
                                    title={type.toString()}
                                    className={`text-center fw-bold ${small ? " " : " border rounded-2"}`}>
                            {small ? <div/> :
                                <TaskFullName type={type} dateSelected={dateSelected} onOpenChange={onOpenChange}
                                              onTaskEditingChange={onTaskEditingChange} tasks={tasks}/>}
                        </DayElement>
                    </Col>
                } else {
                    return <Col key={index} xs={12}></Col>;
                }
            }
        )

        }
    </>
}

function TaskFullName(props) {
    const {tasks, dateSelected, type, onTaskEditingChange, onOpenChange} = props;
    return <>
        {tasks ? [...tasks]?.filter(task => taskIsCurrentDay(task, Number(type), dateSelected) || taskIsCurrentDayAndIsRepeat(task, Number(type), dateSelected))
            ?.map((task, index) => <TaskNote key={index * 100} task={task} onTaskEditingChange={onTaskEditingChange}
                                             onOpenChange={onOpenChange}>
                <div className={"rounded-2 ps-0 pe-0"}>
                    <p className={'text-break rounded-2 text-black text-decoration-underline m-0 p-0'}
                       style={{fontSize: "11px"}}>
                        {`- ${task?.title}`}
                    </p>
                </div>
            </TaskNote>) : ""}
    </>
}

function EmptyDaysOfNextMonth(props) {
    const {endDay, dateSelected, small} = props
    return <>
        {addEmptyDaysOfNextMonth(endDay, dateSelected).map((number, index) => <Col key={index}></Col>)}
    </>
}

